<template>
  <div>
    <template v-for="(tag, index) in tags">
      <a-tooltip v-if="tag.length > maxLength" :key="tag" :title="tag">
        <a-tag :key="tag" :closable="!unClosableList.includes(index)" @close="() => handleClose(tag)">
          {{ `${tag.slice(0, maxLength)}...` }}
        </a-tag>
      </a-tooltip>
      <a-tag v-else :key="tag" :closable="!unClosableList.includes(index)" @close="() => handleClose(tag)">
        {{ tag }}
      </a-tag>
    </template>
    <a-input
      v-if="inputVisible"
      ref="input"
      type="text"
      :size="size"
      :style="{ width: inputWidth }"
      :value="inputValue"
      @change="handleInputChange"
      @blur="handleInputConfirm"
      @keyup.enter="handleInputConfirm"
    />
    <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
      <a-icon type="plus" style="margin-right: 6px"/>
      {{ addTagName }}
    </a-tag>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    unClosableList: {
      type: Array,
      default: function() {
        return []
      }
    },
    maxLength: {
      type: Number,
      default: 20
    },
    inputWidth: {
      type: String,
      default: '80px'
    },
    size: {
      type: String,
      default: 'small'
    },
    addTagName: {
      type: String,
      default: 'New Tag'
    }
  },
  watch: {
    'value': function(newVal, oldVal) {
      this.tags = newVal ? [...newVal] : []
    }
  },

  mounted() {
    this.tags = this.value ? [...this.value] : []
  },
  data() {
    return {
      tags: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    handleClose(removedTag) {
      let newTags = this.tags.filter(tag => tag !== removedTag)
      this.tags = newTags
      this.$emit('input', newTags)
      this.$emit('change', newTags)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(function() {
        this.$refs.input.focus()
      })
    },

    handleInputChange(e) {
      this.inputValue = e.target.value
    },

    handleInputConfirm() {
      const inputValue = this.inputValue
      let tags = this.tags
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: ''
      })
      this.$emit('input', tags)
      this.$emit('change', tags)
    }
  }
}
</script>